<div class="export-modal">
  <div class="modal-header ps-24px">
    <div class="export-modal-header">
      <h5>{{translate?.general.buttons.discard.singular}}&nbsp;{{translate?.report.label.singular}}&nbsp;{{translate?.general.messages.confirmation}}</h5>
    </div>

    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="modalRef.hide();"
      [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
  
    <div class="modal-body pt-2">
      <!-- Destination label -->
      <div class="text-body">
        <span class="content">{{translate?.report.messages.unsavedChangesLostDiscard}} {{translate?.report.label.singular}} {{translate?.report.messages.willBeLostIfDiscard}} {{translate?.report.label.singular}} {{translate?.report.messages.nowYouWantToProceed}}</span>
      </div>
    </div>
     <div class="modal-footer">
      <button type="button" class="custella-btn-white" (click)="modalRef.hide()">
        {{translate?.general.buttons.cancel.singular}}
      </button>
      <p-button [label]="translate?.general.buttons.discard.singular" styleClass="danger" (onClick)="onDiscardReport()"></p-button>
      <p-button label="{{translate?.general.buttons.save.singular}} {{translate?.report.label.singular}}" (onClick)="onSaveReport()"></p-button>
    </div>
  

</div>